import _ from 'lodash';
import { getMeasureValuesColumns } from '../../devextreme/model/pivot-data-model-utils';
import { ChartSpecificColumnType, } from '../../types';
import { getAllColumnsInAxisConfig, getColumn, getColumns, } from '../chart-model-utils';
import { configOptions } from '../chart-type-specification-service';
import { getName } from '../column-name-util';
const getMeasureNamesAndValuesConfig = (chartModel) => {
    return configOptions(chartModel.config.chartType, chartModel)
        .allowedConfigurations.measureNameValueColumns;
};
const isMeasureNamesEnabled = (chartModel) => {
    return getMeasureNamesAndValuesConfig(chartModel).enableMeasureNameColumn;
};
const isMeasureValuesEnabled = (chartModel) => {
    return getMeasureNamesAndValuesConfig(chartModel).enableMeasureValueColumn;
};
const isMeasureNameColumn = (column) => {
    return (column.chartSpecificColumnType === ChartSpecificColumnType.MeasureNames);
};
const isMeasureValueColumn = (column) => {
    return (column.chartSpecificColumnType === ChartSpecificColumnType.MeasureValues);
};
const isMeasureNameOrValueColumn = (column) => {
    return isMeasureNameColumn(column) || isMeasureValueColumn(column);
};
const getOverrideNamesForChartSpecificColumns = (chartModel) => {
    const mnvConfig = getMeasureNamesAndValuesConfig(chartModel);
    return chartModel.columns.reduce((overrideNames, column) => {
        const output = _.cloneDeep(overrideNames);
        if (isMeasureNameColumn(column.column)) {
            output[column.column.id] = column.column.isUserDefinedTitle
                ? getName(column.column)
                : mnvConfig.measureNameColumnAlias;
        }
        if (isMeasureValueColumn(column.column)) {
            output[column.column.id] = column.column.isUserDefinedTitle
                ? getName(column.column)
                : mnvConfig.measureValueColumnAlias;
        }
        return output;
    }, {});
};
const filterMeasureColumnsByChart = (chartModel) => {
    const allColumns = getColumns(chartModel);
    return allColumns.filter(column => {
        if (!isMeasureNamesEnabled(chartModel) && isMeasureNameColumn(column)) {
            return false;
        }
        if (!isMeasureValuesEnabled(chartModel) &&
            isMeasureValueColumn(column)) {
            return false;
        }
        return true;
    });
};
const containsMeasureNamesOrMeasureValuesColumns = (visualAxisConfig) => {
    return getAllColumnsInAxisConfig(visualAxisConfig).some(column => {
        return [
            ChartSpecificColumnType.MeasureNames,
            ChartSpecificColumnType.MeasureValues,
        ].includes(column.chartSpecificColumnType);
    });
};
const findMeasureNameColumnIndex = (columns) => {
    return columns.findIndex(column => column.chartSpecificColumnType ===
        ChartSpecificColumnType.MeasureNames);
};
const getSageColumnsFromColumnId = (chartViz, columnId) => {
    if (_.isNil(columnId)) {
        return [];
    }
    const column = getColumn(chartViz, columnId);
    if (isMeasureNameOrValueColumn(column)) {
        return getMeasureValuesColumns(chartViz);
    }
    return _.compact([column]);
};
export { filterMeasureColumnsByChart, getOverrideNamesForChartSpecificColumns, containsMeasureNamesOrMeasureValuesColumns, isMeasureNameColumn, isMeasureValueColumn, isMeasureNameOrValueColumn, findMeasureNameColumnIndex, getSageColumnsFromColumnId, };
//# sourceMappingURL=index.js.map